import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export interface IShippingCompany {
  id: string;
  name: string;
  code: string;
  minDay: number;
  maxDay: number;
  trackingSiteUrl: string;
  onlineTracking: boolean;
  supportedCustomTax: boolean;
}

export const shippingCompanyApi = createApi({
  reducerPath: 'shippingCompanyApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api' }),
  endpoints: builder => ({
    getShippingCompanies: builder.query<IShippingCompany[], string>({
      query: (codeJoin: string) => ({
        url: '/shipping-companies',
        method: 'GET',
        params: {
          codeJoin,
        },
      }),
      keepUnusedDataFor: 60 * 60,
    }),
  }),
});

export const {
  useGetShippingCompaniesQuery,
  useLazyGetShippingCompaniesQuery,
} = shippingCompanyApi;
